import React, { useState, useCallback, useMemo, useEffect } from 'react';

import Modal from '../../components/Modal';

import ActionButtons from '../../components/ActionButtons';

import { INITIAL_FORM_STATE, INITIAL_FORM_ERRORS, getFormConfig, UPLOAD_SCHEMA, PAGE_CONFIG } from './config';
import clsx from 'clsx';
import { inputStyles, errorStyles } from '../../styles/styles';

const TimelineModal = ({ errors, handleChange, handleSubmit, handleFileChange, form, isOpen, onClose, isEdit = false, selectedItem, setIsEdit, onSubmit, status , timelineMediaTypes}) => {


    // const { t } = useTranslation();
    // const tr = useCallback((key) => t(`timelineAdmin:${key}`), [t]);


    // const formConfig = useMemo(() => getFormConfig(formData, handleInputChange, handleFileChange, errors, isEdit, mediaTypes), [formData, handleInputChange, handleFileChange, errors, isEdit, mediaTypes]);

    // Memoize labels
    const labels = useMemo(
        () => ({
            normalLabel: isEdit ? 'Update Timeline' : 'Create Timeline',
            loadingLabel: isEdit ? 'Updating...' : 'Creating...'
        }),
        [isEdit]
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={isEdit ? 'UPDATE TIMELINE' : 'CREATE NEW TIMELINE'}>
            <form onSubmit={handleSubmit} className="space-y-4">

                {/* Start of new form structure */}
                <div>
                    <label htmlFor="title" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Heading
                    </label>
                    <input
                        id="heading"
                        autoComplete="off"
                        type="text"
                        placeholder="Enter Heading"
                        name="heading"
                        value={form?.heading || ''}
                        onChange={(e) => handleChange('heading', e.target.value)}
                        className={clsx(inputStyles, errors?.heading && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.heading && <p className={errorStyles}>{errors?.heading}</p>}
                </div>
                <div>
                    <label htmlFor="date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Date
                    </label>
                    <input
                        id="date"
                        autoComplete="off"
                        type="date"
                        placeholder="Select date"
                        name="date"
                        value={form?.date || ''}
                        onChange={(e) => handleChange('date', e.target.value)}
                        className={clsx(inputStyles, errors?.date && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.date && <p className={errorStyles}>{errors?.date}</p>}
                </div>
                <div>
                    <label htmlFor="media_type_id" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Media Type
                    </label>
                    <select
                        id="media_type_id"
                        name="media_type_id"
                        value={form?.media_type_id || ''}
                        onChange={(e) => handleChange('media_type_id', e.target.value)}
                        className={clsx(inputStyles, errors?.media_type_id && 'border-red-500 dark:border-red-400')}
                    >
                        <option value="">Select Media Type</option>
                        {timelineMediaTypes?.map((mediaType) => (
                            <option key={mediaType.id} value={mediaType.id}>
                                {mediaType.name}
                            </option>
                        ))}
                    </select>
                    {errors?.media_type_id && <p className={errorStyles}>{errors?.media_type_id}</p>}
                </div>
                <div>
                    <label htmlFor="event" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Event
                    </label>
                    <textarea
                        id="event"
                        name="event"
                        value={form?.event || ''}
                        onChange={(e) => handleChange('event', e.target.value)}
                        className={clsx(inputStyles, errors?.event && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.event && <p className={errorStyles}>{errors?.event}</p>}
                </div>
                <div>
                    <label htmlFor="manual" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Manual
                    </label>
                    <input
                        id="manual"
                        name="manual"
                        type="file"
                        onChange={(e) => handleFileChange('manual', e.target.files[0])}
                        className={clsx(inputStyles, errors?.manual && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.manual && <p className={errorStyles}>{errors?.manual}</p>}
                </div>
                <div>
                    <label htmlFor="thumbnail" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Thumbnail
                    </label>
                    <input
                        id="thumbnail"
                        name="thumbnail"
                        type="file"
                        onChange={(e) => handleFileChange('thumbnail', e.target.files[0])}
                        className={clsx(inputStyles, errors?.thumbnail && 'border-red-500 dark:border-red-400')}
                    />
                    {errors?.thumbnail && <p className={errorStyles}>{errors?.thumbnail}</p>}
                </div>
                <div>
                    <label htmlFor="url" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Url
                    </label>
                    <input
                        id="url"
                        name="url"
                        type="text"
                        placeholder="Enter Url"
                        value={form?.url || ''}
                        onChange={(e) => handleChange('url', e.target.value)}
                        className={clsx(inputStyles, errors?.url && 'border-red-500 dark:border-red-400')}
                    />
                </div>

                <ActionButtons status={status} onClose={onClose} onSubmit={handleSubmit} isEdit={isEdit} label={labels} />
            </form>
        </Modal>
    );
};

export default React.memo(TimelineModal);
